<template>
   <div class="leaps-reflection-question-textbox container-fluid"> 
    <div class="row margin-bottom-2Perc vertical-align"> 
      <div class="col-md-11 col-lg-11 margin-top-0Point5Perc font-color-blue padding-left-0px padding-right-0px">
        <span class="col-md-1 col-lg-1 padding-right-0px padding-left-0px">
          {{currIndex + 1}})
        </span>
        <span class="col-md-11 col-lg-11 padding-right-0px padding-left-0px">
          <div class="form-group text-align-left margin-bottom-0px">
          <span class="font-size-11px"><i>Index:</i></span>
          <span><input type="text" class="form-control" v-model="getCurrentQueIndex"></span>
        </div>
        <div class="form-group text-align-left margin-bottom-0px">
          <span class="font-size-11px"><i>Long Question:</i></span>
          <span><textarea class="form-control" rows="2" v-model="questionText" maxlength="1024"></textarea></span>
        </div>
        <div class="form-group text-align-left">
          <span class="font-size-11px"><i>Short Question:</i></span>
          <span><textarea class="form-control" rows="2" v-model="shortQuestionText" maxlength="1024"></textarea></span>
        </div>
        </span>
      </div>
      <div class="col-md-1 col-lg-1">
        <span class="glyphicon glyphicon-ok-sign cursor-pointer" @click="addNewQuestion"></span>    
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>
</template>
<script>
import AlertBox from '@/components/AlertOverlay'
import { find } from 'lodash'
export default {
  props: ['currIndex', 'currRating', 'aarQuestions'],
  name: 'leaps-reflection-question-textbox',
  created () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currentQueIndex: 0,
      questionText: '',
      shortQuestionText: ''
    }
  },
  components: {
    'alert-box': AlertBox
  },
  methods: {
    setDefaultValues: function () {
      this.currentQueIndex = (this.aarQuestions.length + 1)
      this.questionText = ''
      this.shortQuestionText = ''
    },
    getRandomGuidString: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = Math.random() * 16 | 0
        var v = (c === 'x') ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    addNewQuestion: function () {
      const foundObj = find(this.aarQuestions, (obj) => {
        return parseInt(obj.CurrentQueIndex) === parseInt(this.currentQueIndex)
      })
      if (foundObj === undefined || foundObj === 'undefined' || foundObj === null || foundObj === 'null') {
        if (this.questionText !== undefined && this.questionText !== 'undefined' && this.questionText !== null && this.questionText !== 'null' && this.questionText.trim().length !== 0) {
          if (this.shortQuestionText !== undefined && this.shortQuestionText !== 'undefined' && this.shortQuestionText !== null && this.shortQuestionText !== 'null' && this.shortQuestionText.trim().length !== 0) {
            var objToReturn = {
              OperationName: 'Add_Question',
              Rating: this.currRating,
              Index: this.currIndex,
              CurrentQueIndex: this.currentQueIndex,
              QuestionText: this.questionText,
              ShortQuestion: this.shortQuestionText
            }
            this.$emit('emitValue', objToReturn)
            this.setDefaultValues()
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Short Question Text Can\'t be empty.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Long Question Text Can\'t be empty.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Duplicate index found.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getCurrentQueIndex: {
      get: function () {
        return this.currentQueIndex
      },
      set: function (newValue) {
        if (newValue !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            this.currentQueIndex = parseInt(newValue)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.currentQueIndex = (this.aarQuestions.length + 1)
          }
        } else {
          this.currentQueIndex = (this.aarQuestions.length + 1)
          this.showAlertDialog = true
          this.errorMsg = 'Index can\'t be empty.'
        }
      }
    }
  },
  watch: {
    aarQuestions: function (oldValue, newValue) {
      this.setDefaultValues()
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.margin-bottom-0px {
  margin-bottom: 0px;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-16px {
  font-size: 16px;
}
.font-size-14px {
  font-size: 14px;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-11px {
  font-size: 11px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-top-0Point7Perc {
  margin-top: 0.7%;
}
.margin-top-0Point5Perc {
  margin-top: 0.5%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.glyphicon {
    font-size: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/group/LeapsReflectionQuestionTextBox.vue